import {
  AfterViewInit,
  Directive,
  ElementRef,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appCustomSelectStyle]'
})
export class CustomSelectStyleDirective implements AfterViewInit {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngAfterViewInit(): void {
    this.modifyPaginator();
  }

  private modifyPaginator() {

    const matSelect = this.el.nativeElement.querySelector('.mat-select');
    if (matSelect) {
      this.renderer.setStyle(matSelect, 'font-family', 'Red Hat Display, sans-serif');
    }

    const matFormFieldWrapper = this.el.nativeElement.querySelector('.mat-form-field-wrapper');
    if (matFormFieldWrapper) {
      this.renderer.setStyle(matFormFieldWrapper, 'padding', '0');
    }

    const matFormFieldInfix = this.el.nativeElement.querySelector('.mat-form-field-infix');
    if (matFormFieldInfix) {
      this.renderer.setStyle(matFormFieldInfix, 'padding', '0');
      this.renderer.setStyle(matFormFieldInfix, 'border', '0');
    }

    const underlineSelect = this.el.nativeElement.querySelector('.mat-form-field-underline');
    if (underlineSelect) {
      this.renderer.setStyle(underlineSelect, 'visibility', 'hidden');
    }

    const overlay = this.el.nativeElement.querySelector('.cdk-overlay-container');
    if (overlay) {
      this.renderer.setStyle(overlay, 'z-index', '10000');
    }

    const arrowSelect = this.el.nativeElement.querySelector('.mat-select-arrow-wrapper');
    if (arrowSelect) {
      this.renderer.setProperty(arrowSelect, 'innerHTML', '');

      const img = this.renderer.createElement('img');
      this.renderer.setAttribute(img, 'src', '../../assets/arrow-icon.svg');
      this.renderer.setStyle(img, 'transform', 'rotate(90deg)');
      this.renderer.appendChild(arrowSelect, img);
    }
  }
}
